/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseDTOCreateOutletResponseDTO } from "../models/ApiResponseDTOCreateOutletResponseDTO";
import type { ApiResponseDTOListAddressSuggestionDTO } from "../models/ApiResponseDTOListAddressSuggestionDTO";
import type { ApiResponseDTOListOutletEmployeeDTO } from "../models/ApiResponseDTOListOutletEmployeeDTO";
import type { ApiResponseDTOListOutletListDTO } from "../models/ApiResponseDTOListOutletListDTO";
import type { ApiResponseDTOListOutletPosDTO } from "../models/ApiResponseDTOListOutletPosDTO";
import type { ApiResponseDTOListOutletWalletDTO } from "../models/ApiResponseDTOListOutletWalletDTO";
import type { ApiResponseDTOOutletBalanceResponseDTO } from "../models/ApiResponseDTOOutletBalanceResponseDTO";
import type { ApiResponseDTOOutletListDTO } from "../models/ApiResponseDTOOutletListDTO";
import type { ApiResponseDTOOutletStatusResponseDTO } from "../models/ApiResponseDTOOutletStatusResponseDTO";
import type { ApiResponseDTOOutletWalletDTO } from "../models/ApiResponseDTOOutletWalletDTO";
import type { ApiResponseDTOOutletWithdrawalContextDTO } from "../models/ApiResponseDTOOutletWithdrawalContextDTO";
import type { ApiResponseDTOUserOutletsResponseDTO } from "../models/ApiResponseDTOUserOutletsResponseDTO";
import type { ApiResponseDTO } from "../models/ApiResponseDTO";
import type { CreateOutletRequestDTO } from "../models/CreateOutletRequestDTO";
import type { OutletStatusUpdateRequestDTO } from "../models/OutletStatusUpdateRequestDTO";
import type { SwitchOutletRequestDTO } from "../models/SwitchOutletRequestDTO";
import type { UpdateOutletRequestDTO } from "../models/UpdateOutletRequestDTO";

import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";

export class OutletApiService {
  /**
   * Get address suggestions
   * Retrieves address suggestions from Google Places Autocomplete API
   * @param search
   * @returns ApiResponseDTOListAddressSuggestionDTO Address suggestions retrieved successfully
   * @throws ApiError
   */
  public static getAddressSuggestions(
    search: string
  ): CancelablePromise<ApiResponseDTOListAddressSuggestionDTO> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/addresses",
      query: {
        search: search,
      },
      errors: {
        400: `Invalid request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        422: `Unprocessable Entity`,
        500: `Internal server error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * List outlets
   * Retrieves all outlets for the authenticated merchant
   * @returns ApiResponseDTOListOutletListDTO Outlets retrieved successfully
   * @throws ApiError
   */
  public static listOutlets(): CancelablePromise<ApiResponseDTOListOutletListDTO> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/outlets",
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        422: `Unprocessable Entity`,
        500: `Internal server error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Create outlet
   * Creates a new outlet for the authenticated merchant. Requires Tier 4 status and valid MFA token.
   * @param xMfa
   * @param requestBody
   * @returns ApiResponseDTOCreateOutletResponseDTO Outlet created successfully
   * @throws ApiError
   */
  public static createOutlet(
    xMfa: string,
    requestBody: CreateOutletRequestDTO
  ): CancelablePromise<ApiResponseDTOCreateOutletResponseDTO> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/outlets",
      headers: {
        "X-MFA": xMfa,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Invalid request or business rule violation`,
        401: `Unauthorized`,
        403: `Forbidden - insufficient tier or invalid MFA`,
        404: `Not Found`,
        422: `Unprocessable Entity`,
        500: `Internal server error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Outlet balances
   * Balances for one outlet, or for every outlet the merchant owns when outletId is omitted. The ledger balance is the CBS available balance plus credits that have been paid but not yet applied by the CBS.
   * @param outletId
   * @returns ApiResponseDTOOutletBalanceResponseDTO Balances retrieved successfully
   * @throws ApiError
   */
  public static getOutletBalances(
    outletId?: string
  ): CancelablePromise<ApiResponseDTOOutletBalanceResponseDTO> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/outlets/balances",
      query: {
        outletId: outletId,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Access denied for requested outlet ID`,
        404: `Outlet not found`,
        422: `Unprocessable Entity`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
        503: `Balance could not be retrieved`,
      },
    });
  }

  /**
   * The wallets a merchant's outlets collect into
   * Every outlet the caller owns, with its collecting account number. Used by zenz-transaction-service, which holds the transactions but not the outlets, to report across a merchant without learning the outlet rules.
   * @returns ApiResponseDTOListOutletWalletDTO Wallets retrieved successfully
   * @throws ApiError
   */
  public static getOwnedOutletWallets(): CancelablePromise<ApiResponseDTOListOutletWalletDTO> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/outlets/wallets",
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        422: `Unprocessable Entity`,
        500: `Internal server error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Get outlet details
   * Retrieves detailed information for a specific outlet by ID
   * @param outletId
   * @returns ApiResponseDTOOutletListDTO Outlet retrieved successfully
   * @throws ApiError
   */
  public static getOutletById(
    outletId: string
  ): CancelablePromise<ApiResponseDTOOutletListDTO> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/outlets/{outletId}",
      path: {
        outletId: outletId,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden - no access to this outlet`,
        404: `Outlet not found`,
        422: `Unprocessable Entity`,
        500: `Internal server error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Update outlet
   * Updates an existing outlet. Requires valid MFA token and business ownership.
   * @param outletId
   * @param xMfa
   * @param requestBody
   * @returns ApiResponseDTOCreateOutletResponseDTO Outlet updated successfully
   * @throws ApiError
   */
  public static updateOutlet(
    outletId: string,
    xMfa: string,
    requestBody: UpdateOutletRequestDTO
  ): CancelablePromise<ApiResponseDTOCreateOutletResponseDTO> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/outlets/{outletId}",
      path: {
        outletId: outletId,
      },
      headers: {
        "X-MFA": xMfa,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Invalid request`,
        401: `Unauthorized`,
        403: `Forbidden - invalid MFA or no ownership`,
        404: `Outlet not found`,
        422: `Unprocessable Entity`,
        500: `Internal server error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * List an outlet's employees
   * Staff assigned to this outlet and the role each holds. Returns an empty list when nobody is assigned.
   * @param outletId
   * @returns ApiResponseDTOListOutletEmployeeDTO Retrieved successfully
   * @throws ApiError
   */
  public static getOutletEmployees(
    outletId: string
  ): CancelablePromise<ApiResponseDTOListOutletEmployeeDTO> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/outlets/{outletId}/employees",
      path: {
        outletId: outletId,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden - no access to this outlet`,
        404: `Outlet not found`,
        422: `Unprocessable Entity`,
        500: `Internal server error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * List an outlet's POS terminals
   * Terminals assigned to this outlet, with the account each collects into and whether it is currently active. Returns an empty list when the outlet has no terminals.
   * @param outletId
   * @returns ApiResponseDTOListOutletPosDTO Retrieved successfully
   * @throws ApiError
   */
  public static getOutletPosTerminals(
    outletId: string
  ): CancelablePromise<ApiResponseDTOListOutletPosDTO> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/outlets/{outletId}/pos",
      path: {
        outletId: outletId,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden - no access to this outlet`,
        404: `Outlet not found`,
        422: `Unprocessable Entity`,
        500: `Internal server error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Get an outlet's collecting wallet
   * Returns the wallet account number this outlet collects into. Used by zenz-transaction-service, which holds the transactions but not the outlets, to report on one. Refused unless the caller owns the outlet's business or is assigned to the outlet.
   * @param outletId
   * @returns ApiResponseDTOOutletWalletDTO Wallet resolved successfully
   * @throws ApiError
   */
  /**
   * Activate or deactivate an outlet
   * Switches an outlet between ACTIVE and INACTIVE. Owner only, behind a valid MFA token. The default outlet cannot be deactivated, nor can one that still has transactions settling. Setting the status it already has is a no-op that returns the current state.
   * @param outletId
   * @param xMfa
   * @param requestBody
   * @returns ApiResponseDTOOutletStatusResponseDTO Outlet status updated
   * @throws ApiError
   */
  public static updateOutletStatus(
    outletId: string,
    xMfa: string,
    requestBody: OutletStatusUpdateRequestDTO
  ): CancelablePromise<ApiResponseDTOOutletStatusResponseDTO> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v1/outlets/{outletId}/status",
      path: {
        outletId: outletId,
      },
      headers: {
        "X-MFA": xMfa,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Invalid request`,
        401: `Unauthorized`,
        403: `Forbidden - invalid MFA or not the owner`,
        404: `Outlet not found`,
        422: `Default outlet, or pending transactions`,
        500: `Internal server error`,
        501: `Not Implemented`,
      },
    });
  }

  public static getOutletWallet(
    outletId: string
  ): CancelablePromise<ApiResponseDTOOutletWalletDTO> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/outlets/{outletId}/wallet",
      path: {
        outletId: outletId,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden - no access to this outlet`,
        404: `Outlet not found`,
        422: `Unprocessable Entity`,
        500: `Internal server error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * What an outlet withdrawal needs to know
   * Ownership, status, the outlet's own account and its ledger balance, plus the business wallet a withdrawal can be sent to. Used by zenz-transaction-service, which holds the transfer rail but not the outlet rules, so it can apply the withdrawal guards without learning them.
   * @param outletId
   * @returns ApiResponseDTOOutletWithdrawalContextDTO Context retrieved successfully
   * @throws ApiError
   */
  public static getOutletWithdrawalContext(
    outletId: string
  ): CancelablePromise<ApiResponseDTOOutletWithdrawalContextDTO> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/outlets/{outletId}/withdrawal-context",
      path: {
        outletId: outletId,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Access denied for requested outlet ID`,
        404: `Outlet not found`,
        422: `Unprocessable Entity`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
        503: `Balance could not be retrieved`,
      },
    });
  }

  /**
   * Outlets the caller may act on
   * The outlets the authenticated user owns, plus the ones they are assigned to, each with the role that grants the access.
   * @param balances
   * @returns ApiResponseDTOUserOutletsResponseDTO Outlets retrieved successfully
   * @throws ApiError
   */
  public static getPermittedOutlets(
    balances?: boolean
  ): CancelablePromise<ApiResponseDTOUserOutletsResponseDTO> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/users/me/outlets",
      query: {
        balances: balances,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        422: `Unprocessable Entity`,
        500: `Internal server error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Switch the signed-in outlet
   * Makes the given outlet the one the signed-in session acts at. The services
   * that scope by the session pick the new outlet up from here rather than
   * taking a filter of their own.
   * @param requestBody
   * @returns ApiResponseDTO Outlet switched successfully
   * @throws ApiError
   */
  public static switchOutlet(
    requestBody: SwitchOutletRequestDTO
  ): CancelablePromise<ApiResponseDTO> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/users/me/outlet",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        422: `Unprocessable Entity`,
        500: `Internal server error`,
        501: `Not Implemented`,
      },
    });
  }
}
